import format from 'date-fns/format';
import addDays from 'date-fns/add_days';

import { FETCH_SESSIONS_SUCCESS, FETCH_SESSIONS_FAIL } from '../../../actions/sessions';

import { handleError, isSuccess } from '../../../../fetch_helpers/post_helpers';

import { SetSessions } from '../../../database/helpers';

import { shouldUpdate } from './fetch_local_sessions';

// import { processSessions } from '../../../database/processors';

import { CreateAPI, CreateKey, ProcessSessions, StoreSessions } from './processors';

const checkLocalSessions = async (db, keyCreator) => {
  let i = 1;
  let update = false;
  let checkDate = addDays(new Date(), i);
  update = await shouldUpdate(db, checkDate, keyCreator(checkDate));
  if (update) return checkDate;

  do {
    i += 1;
    checkDate = addDays(new Date(), i);
    /* eslint-disable no-await-in-loop */
    update = await shouldUpdate(db, checkDate, keyCreator(checkDate));
    if (update) i = 15;
    /* eslint-enable no-await-in-loop */
  } while (i < 14 && !update);
  // console.log(update, checkDate);
  if (update) return checkDate;
  return update;
};

export default ({ db, currentStore }) => {
  // const { db, currentStore } = dataStore;
  const setSessions = SetSessions(db, currentStore);
  const keyCreator = CreateKey(currentStore);
  return async ({ getState }, next) => {
    const updateDate = await checkLocalSessions(db, keyCreator);
    if (!updateDate) return next({ type: FETCH_SESSIONS_SUCCESS, message: 'All sessions are up to date' });

    const state = getState();

    const errorMessage = handleError(next, FETCH_SESSIONS_FAIL);
    console.log('fetching')
    // const successMessage = getSuccessHandler(next, date);

    try {
      const response = await fetch(CreateAPI(state.sessions.url, updateDate));
      const res = await response.json();
      console.log('fetching', res)
      // console.log('res:', res, isSuccess(response));
      if ((isSuccess(response) && Object.entries(res).length > 0) || res.length > 0) {
        const items = ProcessSessions(res);
        console.log('items', items);
        await StoreSessions(setSessions, items);
        return next({ type: FETCH_SESSIONS_SUCCESS, message: 'All sessions are up to date' });
      }
      if (isSuccess(response)) {
        console.log('no items');
        await setSessions([], updateDate);
        return next({ type: FETCH_SESSIONS_SUCCESS, message: 'All sessions are up to date' });
      }
      // Failure
      return errorMessage(res);
    } catch (error) {
      return errorMessage(error);
    }
  };
};
